<div class="container">

  <app-header-dialog [iconName]="'edit'">
    TPI/CCV
  </app-header-dialog>

  <div class='content'>

    <form name="form" [formGroup]='form' autocomplete="off">

      <div style="display: flex; flex-direction: row; justify-content: space-between;">

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Data</mat-label>
          <input matInput [matDatepicker]="pickerDate" [errorStateMatcher]="matcher" [formControl]="form.controls.date">
          <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
          <mat-datepicker #pickerDate></mat-datepicker>
        </mat-form-field>

      </div>


      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="form.controls.text" autocomplete="off">
        <mat-error *ngIf="form.controls.text.hasError('required')">
          A descrição é obrigatória
        </mat-error>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]='form.invalid' mat-raised-button (click)="matDialogRef.close([ 'add', form ])" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

    <button [disabled]='form.invalid' mat-raised-button (click)="matDialogRef.close([ 'edit', form ])" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>